import React from 'react';
import { DocumentSelector } from '../../DocumentSelector';
import { SpecDocInfo } from './types';

interface SpecificationDocumentPaneProps {
  heading: string;
  label: string;
  selectedDocumentId?: string;
  docInfo: SpecDocInfo | null;
  onSelect: (documentId: string, content: string, fileName: string, title: string) => void;
  onClear: () => void;
  error?: string;
  disabled: boolean;
}

const SpecificationDocumentPane: React.FC<SpecificationDocumentPaneProps> = ({
  heading,
  label,
  selectedDocumentId,
  docInfo,
  onSelect,
  onClear,
  error,
  disabled,
}) => (
  <div>
    <p className="revy-cjk mb-1 text-sm font-medium leading-[1.5] text-muted-foreground">
      {heading}
    </p>
    <DocumentSelector
      label={label}
      selectedDocumentId={selectedDocumentId}
      selectedFileName={docInfo?.fileName}
      contentPreview={docInfo?.preview}
      onSelect={onSelect}
      onClear={onClear}
      error={error}
      disabled={disabled}
    />
  </div>
);

export default SpecificationDocumentPane;
